import { render, staticRenderFns } from "./PunchCardDetail.vue?vue&type=template&id=264d8e27&scoped=true&"
import script from "./PunchCardDetail.vue?vue&type=script&lang=js&"
export * from "./PunchCardDetail.vue?vue&type=script&lang=js&"
import style0 from "./PunchCardDetail.vue?vue&type=style&index=0&id=264d8e27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d8e27",
  null
  
)

export default component.exports